import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ItAssetsService } from '@core/services/itAssets.service';
import { ItAssetsActions } from './itassets.actions';

@Injectable()
export class ItAssetsEffects {
  private actions$ = inject(Actions);
  private itAssetsService = inject(ItAssetsService);
  private translateService = inject(TranslateService);
  getItAssets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ItAssetsActions.loadItAssets),
      mergeMap((data) =>
        this.itAssetsService.getItAssets(data).pipe(
          map((itAssets) =>
            itAssets.success
              ? ItAssetsActions.loadItAssetsSuccess(itAssets)
              : ItAssetsActions.loadItAssetsFailure(itAssets)
          ),
          catchError((error) =>
            of(
              ItAssetsActions.loadItAssetsFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  addItAssets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ItAssetsActions.addEditItAssets),
      mergeMap((data) =>
        this.itAssetsService.addItAssets(data.ItAssets).pipe(
          map((itAssets) => {
            if (itAssets.success) {
              return data.ItAssets.id
                ? ItAssetsActions.updateItAssetsSuccess(itAssets)
                : ItAssetsActions.addItAssetsSuccess(itAssets);
            } else return ItAssetsActions.addItAssetsFailure(itAssets);
          }),
          catchError((error) =>
            of(
              ItAssetsActions.addItAssetsFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  deleteItAssets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ItAssetsActions.deleteItAssets),
      mergeMap((data) =>
        this.itAssetsService.deleteItAssets(data.id).pipe(
          map((response) =>
            response.success
              ? ItAssetsActions.deleteItAssetsSuccess({
                  ...response,
                  id: data.id,
                })
              : ItAssetsActions.deleteItAssetsFailure(response)
          ),
          catchError((error) =>
            of(
              ItAssetsActions.deleteItAssetsFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  assignAsset$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ItAssetsActions.assignAsset),
      mergeMap((data) =>
        this.itAssetsService.assignAsset(data).pipe(
          map((itAssets) => {
            if (itAssets.success) {
              return ItAssetsActions.assignAssetSuccess(itAssets);
            } else return ItAssetsActions.assignAssetFailure(itAssets);
          }),
          catchError((error) =>
            of(
              ItAssetsActions.assignAssetFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  deAssignAsset$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ItAssetsActions.deAssignAsset),
      mergeMap((data) =>
        this.itAssetsService.deAssignAsset(data).pipe(
          map((itAssets) => {
            if (itAssets.success) {
              return ItAssetsActions.deAssignAssetSuccess(itAssets);
            } else return ItAssetsActions.deAssignAssetFailure(itAssets);
          }),
          catchError((error) =>
            of(
              ItAssetsActions.deAssignAssetFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
